import { all, takeEvery, put, call } from 'redux-saga/effects'
import { history } from 'index'
import {
  Auth_login,
  Auth_currentAccount,
  Auth_logout,
  Auth_invalidate,
  Verify_OTP,
} from 'services/auth'
import Scopes from 'services/scope'
import Common from 'services/common'
import ClusterService from 'services/cluster_apis'
import actions from './actions'
import getMenuData from 'services/menu'
import { createHashHistory } from 'history'
import RouteAccess from 'services/route_access'

var content_manager

function* AfterLoginPrequisites(payload, success) {
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  })
  var SelectedCluster = {}
  var SelectedScope = {}
  var policyPath
  var accRole = '',
    data = success.data.data
  var name = data.name
  var numclusters = data.access.length
  const { emailId } = payload
  var Access = RouteAccess.NO_ACCESS
  var i = 0,
    j = 0,
    k = 0
  const getAccData = yield call(
    Scopes.getUserAccessDetails,
    success.data.data.SSID,
    success.data.data.SSID,
  )
  if (
    getAccData.data === null ||
    (getAccData.data && Object.keys(getAccData.data.data).length === 0)
  ) {
    getAccData.data = { data: success.data.data }
  }
  if (
    getAccData.data.data.isRoot ||
    getAccData.data.data.userType === RouteAccess.CONTENT_MNGR_API ||
    content_manager === RouteAccess.CONTENT_MNGR_API ||
    (getAccData.data.data?.access?.length > 0 &&
      getAccData.data.data.access.filter(d => d.access_type === RouteAccess.ADMINISTRATOR).length >
        0)
  ) {
    const getTenantList = yield call(ClusterService.getTenantList, success.data.data.SSID, {
      size: 1000,
      query: '',
      add_filter: [],
      page: 1,
    })
    if (getTenantList.data.data.length === 0) {
      accRole = `${RouteAccess.ROOT} - ${RouteAccess.INIT}` // No tenants created yet so redirect Root user
    } // with the 'Root - Init' access to  tenants list page to create a first tenant.
    else {
      // create a access object to process further
      var accessMap = {}
      if (getAccData.data?.data?.access?.length > 0) {
        getAccData.data.data.access.map(d => (accessMap[d.clusterId] = d))
      }
      let tmpAccessList = []
      let tenantsAccessMap = {}
      getTenantList.data.data.map(d => {
        let accessDetails = {
          access_type: accessMap[d['clusterId']]
            ? accessMap[d['clusterId']].access_type
            : RouteAccess.NO_ACCESS,
          clusterId: d['clusterId'],
          clusterName: d['clusterName'],
          licenseType: d['licenseType'] ? d['licenseType'] : '',
          productType: d['productType'] ? d['productType'] : '',
          scope_access: d.scope_list
            .filter(d => d.is_enabled)
            .map(d => {
              let tmpScopeD = {
                scope_id: d.scope_id,
                scope_name: d.scope_name,
                role: RouteAccess.NO_ACCESS,
              }
              if (accessMap[d['cluster_id']]?.scope_access?.length > 0) {
                accessMap[d['cluster_id']].scope_access.map(d1 => {
                  if (d1.scope_id === d.scope_id) {
                    tmpScopeD.role = d1.role
                  }
                })
              }
              return tmpScopeD
            }),
        }
        tenantsAccessMap[d.clusterId] = d
        tmpAccessList.push(accessDetails)
      })
      if (getAccData.data.data?.access?.length > 0) {
        getAccData.data.data.access.map(d => {
          if (!tenantsAccessMap[d.clusterId]) {
            tmpAccessList.push(d)
          }
        })
      }
      getAccData.data.data.access = tmpAccessList
    }
  }
  if (getAccData) {
    yield put({
      type: 'accdetails/SET_ACCDETAILS',
      payload: getAccData.data.data,
    })
    SelectedScope = {}
    SelectedCluster = { scope_access: [], access_type: RouteAccess.NO_ACCESS }
    var enabledScopelist = getAccData.data.data
    var accClusterCount = 0
    for (var i = 0; i < getAccData.data.data.access.length; i++) {
      if (
        getAccData.data.data.isRoot ||
        content_manager === RouteAccess.CONTENT_MNGR_API ||
        getAccData.data.data.userType === RouteAccess.CONTENT_MNGR_API
      ) {
        SelectedCluster = getAccData.data.data.access[i]
        break
      } else {
        var selectClus = {}
        for (let j = 0; j < getAccData.data.data.access[i].scope_access.length; j++) {
          if (getAccData.data.data.access[i].access_type === RouteAccess.ADMINISTRATOR) {
            selectClus = getAccData.data.data.access[i]
            break
          } else if (
            getAccData.data.data.access[i].scope_access[j].role !== RouteAccess.NO_ACCESS
          ) {
            selectClus = getAccData.data.data.access[i]
            break
          }
        }
        if (Object.keys(selectClus).length > 0) {
          SelectedCluster = selectClus
          break
        }
      }
    }
    getAccData.data.data.isRoot &&
      getAccData.data.data.access.map((access, index) => {
        if (access.access_type !== RouteAccess.NO_ACCESS) {
          accClusterCount += 1
        }
      })
    let userRolePriority = {
      'No Access': 0,
      Viewer: 1,
      'Security Analyst': 2,
      'Security Engineer': 3,
    }
    let highestRole = ''
    if (
      !enabledScopelist.isRoot &&
      !enabledScopelist.isOrgAdmin &&
      content_manager !== RouteAccess.CONTENT_MNGR_API &&
      enabledScopelist.userType !== RouteAccess.CONTENT_MNGR_API
    ) {
      if (SelectedCluster.scope_access.length > 0) {
        highestRole = SelectedCluster.scope_access[0]['role']
        if (SelectedCluster.access_type === RouteAccess.ADMINISTRATOR) {
          accRole = `${RouteAccess.USER} - ${RouteAccess.TENANT_ADMIN} - ${SelectedCluster.scope_access[0]['role']}`
          Access = accRole
          SelectedScope = SelectedCluster.scope_access[0]
        } else {
          accRole = `${RouteAccess.USER} - ${SelectedCluster.scope_access[0]['role']}`
          Access = accRole
          SelectedScope = SelectedCluster.scope_access[0]
        }
        for (let j = 0; j < SelectedCluster.scope_access.length; j++) {
          if (
            userRolePriority[highestRole] <
            userRolePriority[SelectedCluster.scope_access[j]['role']]
          ) {
            highestRole = SelectedCluster.scope_access[j]['role']
            if (SelectedCluster.access_type === RouteAccess.ADMINISTRATOR) {
              accRole = `${RouteAccess.USER} - ${RouteAccess.TENANT_ADMIN} - ${SelectedCluster.scope_access[j]['role']}`
              Access = accRole
              SelectedScope = SelectedCluster.scope_access[j]
            } else {
              accRole = `${RouteAccess.USER} - ${SelectedCluster.scope_access[j]['role']}`
              Access = accRole
              SelectedScope = SelectedCluster.scope_access[j]
            }
          }
        }
      } else {
        if (SelectedCluster.access_type === RouteAccess.ADMINISTRATOR) {
          accRole = `${RouteAccess.USER} - ${RouteAccess.TENANT_ADMIN}`
        } else {
          accRole = `${RouteAccess.USER} - ${RouteAccess.NO_ACCESS}`
        }
      }
    } else if (enabledScopelist.isOrgAdmin) {
      if (SelectedCluster.scope_access.length > 0) {
        highestRole = SelectedCluster.scope_access[0]['role']
        if (SelectedCluster.access_type === RouteAccess.ADMINISTRATOR) {
          accRole = `${RouteAccess.ORG_ADMIN} - ${RouteAccess.TENANT_ADMIN} - ${SelectedCluster.scope_access[0]['role']}`
          Access = accRole
          SelectedScope = SelectedCluster.scope_access[0]
        } else {
          accRole = `${RouteAccess.ORG_ADMIN} - ${SelectedCluster.scope_access[0]['role']}`
          Access = accRole
          SelectedScope = SelectedCluster.scope_access[0]
        }
        for (let j = 0; j < SelectedCluster.scope_access.length; j++) {
          if (
            userRolePriority[highestRole] <
            userRolePriority[SelectedCluster.scope_access[j]['role']]
          ) {
            highestRole = SelectedCluster.scope_access[j]['role']
            if (SelectedCluster.access_type === RouteAccess.ADMINISTRATOR) {
              accRole = `${RouteAccess.ORG_ADMIN} - ${RouteAccess.TENANT_ADMIN} - ${SelectedCluster.scope_access[j]['role']}`
              Access = accRole
              SelectedScope = SelectedCluster.scope_access[j]
            } else {
              accRole = `${RouteAccess.ORG_ADMIN} - ${SelectedCluster.scope_access[j]['role']}`
              Access = accRole
              SelectedScope = SelectedCluster.scope_access[j]
            }
          }
        }
      } else {
        if (SelectedCluster.access_type === RouteAccess.ADMINISTRATOR) {
          accRole = `${RouteAccess.ORG_ADMIN} - ${RouteAccess.TENANT_ADMIN}`
        } else {
          accRole = `${RouteAccess.ORG_ADMIN} - ${RouteAccess.NO_ACCESS}`
        }
      }
    } else if (
      enabledScopelist.userType === RouteAccess.CONTENT_MNGR_API ||
      content_manager === RouteAccess.CONTENT_MNGR_API
    ) {
      if (SelectedCluster.scope_access.length > 0) {
        highestRole = SelectedCluster.scope_access[0]['role']
        if (SelectedCluster.access_type === RouteAccess.ADMINISTRATOR) {
          accRole = `${RouteAccess.CONTENT_MNGR} - ${RouteAccess.TENANT_ADMIN} - ${SelectedCluster.scope_access[0]['role']}`
          Access = accRole
          SelectedScope = SelectedCluster.scope_access[0]
        } else {
          accRole = `${RouteAccess.CONTENT_MNGR} - ${SelectedCluster.scope_access[0]['role']}`
          Access = accRole
          SelectedScope = SelectedCluster.scope_access[0]
        }
        for (let j = 0; j < SelectedCluster.scope_access.length; j++) {
          if (
            userRolePriority[highestRole] <
            userRolePriority[SelectedCluster.scope_access[j]['role']]
          ) {
            highestRole = SelectedCluster.scope_access[j]['role']
            if (SelectedCluster.access_type === RouteAccess.ADMINISTRATOR) {
              accRole = `${RouteAccess.CONTENT_MNGR} - ${RouteAccess.TENANT_ADMIN} - ${SelectedCluster.scope_access[j]['role']}`
              Access = accRole
              SelectedScope = SelectedCluster.scope_access[j]
            } else {
              accRole = `${RouteAccess.CONTENT_MNGR} - ${SelectedCluster.scope_access[j]['role']}`
              Access = accRole
              SelectedScope = SelectedCluster.scope_access[j]
            }
          }
        }
      } else {
        if (SelectedCluster.access_type === RouteAccess.ADMINISTRATOR) {
          accRole = `${RouteAccess.CONTENT_MNGR} - ${RouteAccess.TENANT_ADMIN}`
        } else {
          accRole = `${RouteAccess.CONTENT_MNGR} - ${RouteAccess.NO_ACCESS}`
        }
      }
    } else {
      if (SelectedCluster.scope_access.length > 0) {
        highestRole = SelectedCluster.scope_access[0]['role']
        if (SelectedCluster.access_type === RouteAccess.ADMINISTRATOR) {
          accRole = `${RouteAccess.ROOT} - ${RouteAccess.TENANT_ADMIN} - ${SelectedCluster.scope_access[0]['role']}`
          Access = accRole
          SelectedScope = SelectedCluster.scope_access[0]
        } else {
          accRole = `${RouteAccess.ROOT} - ${SelectedCluster.scope_access[0]['role']}`
          Access = accRole
          SelectedScope = SelectedCluster.scope_access[0]
        }
        for (let j = 0; j < SelectedCluster.scope_access.length; j++) {
          if (
            userRolePriority[highestRole] <
            userRolePriority[SelectedCluster.scope_access[j]['role']]
          ) {
            highestRole = SelectedCluster.scope_access[j]['role']
            if (SelectedCluster.access_type === RouteAccess.ADMINISTRATOR) {
              accRole = `${RouteAccess.ROOT} - ${RouteAccess.TENANT_ADMIN} - ${SelectedCluster.scope_access[j]['role']}`
              Access = accRole
              SelectedScope = SelectedCluster.scope_access[j]
            } else {
              accRole = `${RouteAccess.ROOT} - ${SelectedCluster.scope_access[j]['role']}`
              Access = accRole
              SelectedScope = SelectedCluster.scope_access[j]
            }
          }
        }
      } else {
        if (SelectedCluster.access_type === RouteAccess.ADMINISTRATOR) {
          accRole = `${RouteAccess.ROOT} - ${RouteAccess.TENANT_ADMIN}`
        } else {
          accRole = `${RouteAccess.ROOT} - ${RouteAccess.NO_ACCESS}`
        }
      }
    }
  }
  const userPayload = {
    id: emailId,
    name: name,
    email: emailId,
    role: accRole,
    authorized: true,
    licenseType: Object.keys(SelectedCluster).length > 0 ? SelectedCluster.licenseType : '',
    clusterId: Object.keys(SelectedCluster).length > 0 ? SelectedCluster.clusterId : '',
    scope_id: Object.keys(SelectedScope).length > 0 ? SelectedScope.scope_id : '',
    selectedCluster: SelectedCluster,
    selectedScope: SelectedScope,
    AllAccessData: getAccData.data,
    eulaStatus: getAccData.data.data.EULA,
    isPolicyAccepted: getAccData.data.data.isPolicyAccepted,
    otpStatus: success,
    otpInvalid: success.data.status === 'error' ? true : false,
  }

  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: false,
    },
  })
  yield put({
    type: 'user/LOAD_CURRENT_ACCOUNT',
  })
  yield put({
    type: 'user/SET_STATE',
    payload: userPayload,
  })

  yield put({
    type: 'accdetails/SET_ACCDETAILS',
    payload: {
      selectedCluster: SelectedCluster,
      selectedScope: SelectedScope,
    },
  })
  var version = localStorage.getItem('version')
  if (version === undefined || version === null || version !== Common.version) {
    localStorage.clear()
    sessionStorage.clear()
    localStorage.setItem('version', Common.version)
  }
  localStorage.setItem('UserAcc', accRole)
  localStorage.setItem('userPayload', JSON.stringify(userPayload))
  localStorage.setItem('IsInvalid', false)
  localStorage.setItem('SSID', success.data.data.SSID)
  localStorage.setItem('loginStatus', 'success')
  localStorage.setItem('email', payload.emailId)
  localStorage.setItem('name', name)
  localStorage.setItem('notifMsg', JSON.stringify([]))
  localStorage.setItem('app.settings.theme', 'dark')
  localStorage.setItem('app.settings.menuColor', 'dark')
  localStorage.setItem('app.settings.isMenuCollapsed', true)
  var historyURLpath = localStorage.getItem('historyURL')
  var menuData = yield call(getMenuData)
  var path = ''
  var pathObj = {}
  var scopeID = Object.keys(SelectedScope).length > 0 ? '/' + SelectedScope.scope_id : ''
  var clusterID = SelectedCluster.clusterId ? '/' + SelectedCluster.clusterId : ''
  if (!RouteAccess.USER_NO_ACCESS_ROLES.includes(accRole)) {
    if (
      JSON.parse(localStorage.getItem('userPayload')).isPolicyAccepted === undefined ||
      JSON.parse(localStorage.getItem('userPayload')).isPolicyAccepted === false
    ) {
      policyPath = clusterID + scopeID + '/privacy/'
    }
    // if (
    //   JSON.parse(localStorage.getItem('userPayload')).isPolicyAccepted === undefined ||
    //   JSON.parse(localStorage.getItem('userPayload')).isPolicyAccepted === false
    // ) {
    //   policyPath = clusterID + scopeID + '/privacy/'
    // }
    if (RouteAccess.ROOT_INIT_ROLES.includes(accRole)) {
      path = '/admin/tenants/list'
    } else if (RouteAccess.ROOT_NO_ACCESS_ROLES.includes(accRole)) {
      path = '/' + SelectedCluster.clusterId + scopeID + '/admin/components'
    } else if (RouteAccess.ORG_ADMIN_NO_ACCESS_ROLES.includes(accRole)) {
      path = '/admin/organizations/list'
    } else if (RouteAccess.CONTENT_MNGR_NO_ACCESS_ROLES.includes(accRole)) {
      path = '/' + SelectedCluster.clusterId + scopeID + '/system/streamfieldaddition'
    } else if (RouteAccess.ONLY_TENANT_ADMIN_ROLES.includes(accRole)) {
      path = '/' + SelectedCluster.clusterId + scopeID + '/admin/tenants/list'
    } else if (RouteAccess.VIEWER_ROLES.includes(accRole)) {
      path = '/' + SelectedCluster.clusterId + scopeID + '/dashboard'
    } else {
      if (
        historyURLpath &&
        historyURLpath !== 'null' &&
        historyURLpath !== null &&
        historyURLpath !== 'undefined' &&
        historyURLpath.indexOf('/auth/sso/') === -1 &&
        historyURLpath.indexOf('/auth/404') === -1 &&
        historyURLpath !== '/auth/login/verify-otp'
        // false
      ) {
        path = historyURLpath
      } else {
        if (accClusterCount > 1) {
          path = '/' + SelectedCluster.clusterId + scopeID + '/home/'
        } else {
          path =
            '/' +
            SelectedCluster.clusterId +
            scopeID +
            '/home' +
            scopeID +
            '/' +
            SelectedCluster.clusterId
          // path = '/' + SelectedCluster.clusterId + scopeID + '/workbook/new'
          if (
            SelectedCluster.scope_access.filter(
              d => d.role === RouteAccess.SEC_ENG || d.role === RouteAccess.SEC_ANALYST,
            ).length > 1
          ) {
            path =
              '/' + SelectedCluster.clusterId + scopeID + '/home/scope/' + SelectedCluster.clusterId
          } else {
            path =
              '/' +
              SelectedCluster.clusterId +
              scopeID +
              '/home' +
              scopeID +
              '/' +
              SelectedCluster.clusterId
            // var path = '/' + SelectedCluster.clusterId + scopeID + '/workbook/new'
          }
        }
      }
    }
    for (var i = 0; i < menuData.length; i++) {
      if (menuData[i]['url']) {
        menuData[i]['url'] = menuData[i]['url'].replace(
          '//',
          '/' + SelectedCluster.clusterId + scopeID,
        )
      }
      if (menuData[i]['children']) {
        var sysMenu = menuData[i]['children']
        var removeSysMenuElements = []
        for (var j = 0; j < sysMenu.length; j++) {
          if (!sysMenu[j]['roles'].includes(accRole)) {
            removeSysMenuElements.push(j)
          }
        }
        var newSysMenu = []
        for (var j = 0; j < sysMenu.length; j++) {
          if (!removeSysMenuElements.includes(j)) {
            newSysMenu.push(sysMenu[j])
          }
        }
        menuData[i]['children'] = JSON.parse(JSON.stringify(newSysMenu))
        for (var j = 0; j < menuData[i]['children'].length; j++) {
          if (menuData[i]['children'][j]['url'].length > 0) {
            menuData[i]['children'][j]['url'] = menuData[i]['children'][j]['url'].replace(
              '//',
              '/' + SelectedCluster.clusterId + scopeID,
            )
          }
        }
      }
    }
  } else {
    path = '/no-access/auth/no-access'
    menuData = []
  }
  // }
  // else {
  //   var path = '/no-access/auth/no-access'
  //   menuData = []
  // }

  yield put({
    type: 'menu/SET_STATE',
    payload: {
      menuData,
    },
  })
  if (policyPath) {
    localStorage.setItem('acceptPath', path)
    localStorage.removeItem('historyURL')
    yield history.push(policyPath)
  } else if (historyURLpath !== null) {
    localStorage.removeItem('historyURL')
    yield history.replace(path)
  } else {
    localStorage.removeItem('historyURL')
    yield history.push(path)
  }
}

export function* LOGIN({ payload }) {
  const { emailId } = payload
  // const provider = reduxStore.getState().settings.authProvider
  const login = Auth_login
  // const login = provider === 'dnif' ? Auth_login : FB_login
  var success = ''
  // var Access = RouteAccess.NO_ACCESS
  try {
    success = yield call(login, payload)
    if (
      success &&
      success.data.data.mfa_flag === 'disabled' &&
      success.data.data.SSID
      // &&
      // success.data.data.access.length > 0
    ) {
      content_manager =
        success.data.data.userType === 'Content Manager' ? success.data.data.userType : undefined
      yield AfterLoginPrequisites(payload, success)
    } else if (success && success.data.data.mfa_flag === 'enabled') {
      yield put({
        type: 'user/SET_STATE',
        payload: {
          loading: false,
        },
      })
      var path = '/auth/login/verify-otp'
      history.push({ pathname: path, state: success.data.data })
    } else {
      yield put({
        type: 'user/SET_STATE',
        payload: {
          loading: false,
        },
      })
    }
  } catch (error) {
    Common.showNotifications(
      'error',
      error.response ? error.response.data.message : 'Login verification failed',
    )
    yield put({
      type: 'user/SET_STATE',
      payload: {
        loading: false,
      },
    })
  }
}

export function* SSO_LOGIN({ payload }) {
  yield AfterLoginPrequisites(payload, payload.data)
}

export function* HANDOFF_LOGIN({ payload }) {
  yield AfterLoginPrequisites(payload, payload.data)
}

export function* VERIFY_OTP({ payload }) {
  const verify_otp = Verify_OTP
  var success = ''
  // var Access = RouteAccess.NO_ACCESS
  try {
    success = yield call(verify_otp, payload)
    if (
      success &&
      success.data.data.SSID
      // && success.data.data.access.length > 0
    ) {
      yield AfterLoginPrequisites(payload, success)
    } else {
      yield put({
        type: 'user/SET_STATE',
        payload: {
          loading: false,
          otpStatus: success,
        },
      })
    }
  } catch (error) {
    yield put({
      type: 'user/SET_STATE',
      payload: {
        loading: false,
        otpInvalid: error.response.data.status === 'error' ? true : false,
      },
    })
  }
}

export function* LOAD_CURRENT_ACCOUNT() {
  const currentAccount = Auth_currentAccount
  // const currentAccount = provider === 'dnif' ? Auth_currentAccount : FB_currentAccount
  const history = createHashHistory()
  if (history.location.pathname.indexOf('/auth/') === -1 && history.location.pathname !== '/') {
    var historyURLmain = history.location.pathname + history.location.search
    localStorage.setItem('historyURL', historyURLmain)
  }

  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const response = yield call(currentAccount)
  if (response) {
  }
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: false,
    },
  })
}

export function* LOGOUT({ payload }) {
  // const logout = provider === 'dnif' ? Auth_logout : FB_logout
  const logout = Auth_logout
  const invalidate = Auth_invalidate
  // var ssid = localStorage.getItem('SSID')
  // var SelectedCluster = Common.getSelectedCluster()
  var obj = {
    SSID: payload.ssid,
    clusterId: payload.clusterId,
  }
  // var obj = { SSID: payload.ssid, clusterId: SelectedCluster.clusterId }
  yield put({
    type: 'user/SET_STATE',
    payload: {
      id: '',
      name: '',
      role: 'User - Viewer',
      email: '',
      avatar: '',
      licenseType: '',
      authorized: false,
      loading: false,
      eulaStatus: true,
    },
  })
  localStorage.setItem('SSID', '')
  localStorage.setItem('email', '')
  localStorage.removeItem('payload')
  if (payload.clusterId) {
    var invalid = yield call(invalidate, obj)
  }
  var success = yield call(logout, obj)
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.LOGIN, LOGIN),
    takeEvery(actions.SSO_LOGIN, SSO_LOGIN),
    takeEvery(actions.HANDOFF_LOGIN, HANDOFF_LOGIN),
    takeEvery(actions.VERIFY_OTP, VERIFY_OTP),
    takeEvery(actions.LOAD_CURRENT_ACCOUNT, LOAD_CURRENT_ACCOUNT),
    takeEvery(actions.LOGOUT, LOGOUT),
    LOAD_CURRENT_ACCOUNT(), // run once on app load to check user auth
  ])
}
